module.exports = __webpack_public_path__ + "media/images/pdf-file-icon-4efd84d532405d2485e8c2409d0c7d9ec77f53cb57870f1d03864b0baf606135.svg";